import { render, staticRenderFns } from "./UserGenerateImage_OLD.vue?vue&type=template&id=56d324b1&"
import script from "./UserGenerateImage_OLD.vue?vue&type=script&lang=js&"
export * from "./UserGenerateImage_OLD.vue?vue&type=script&lang=js&"
import style0 from "./UserGenerateImage_OLD.vue?vue&type=style&index=0&id=56d324b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports